import uploadService from './request/service/fileupload-service';
import fontService from './request/service/font-service'

let util = {};
util.fullPath = '';
util.html2canvas = ($el, width, height) => {
    return new Promise((resolve, reject) => {
        let w = +width || $el.offsetWidth;
        let h = +height || $el.offsetHeight;
        //要将 canvas 的宽高设置成容器宽高的 2 倍
        let canvas = document.createElement("canvas");
        let scaleVal = 1;
        canvas.width = w * scaleVal;
        canvas.height = h * scaleVal;
        canvas.style.width = w + "px";
        canvas.style.height = h + "px";
        let context = canvas.getContext("2d");
        //然后将画布缩放，将图像放大两倍画到画布上
        context.scale(scaleVal, scaleVal);
        // eslint-disable-next-line
        html2canvas($el, {
            useCORS: true,
            canvas: canvas
        }).then((canvas) => {
            resolve(canvas);
        }).catch((err) => {
            console.error('html2canvas =>', err);
            reject(err);
        });
    });
};

function loadImg(url) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.setAttribute("crossOrigin", 'Anonymous');
        if (url.indexOf('http') === 0) {
            img.src = url + '?v=' + new Date().getTime();
        } else {
            img.src = url;
        }
        img.onload = () => {
            resolve(img);
        }
        img.onerror = () => {
            reject(img);
        }
    });
}

util.mergeImgFromUrl = async function (originUrl, otherUrl, plusHeight) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    canvas.style.display = 'none';
    document.body.appendChild(canvas);
    let img1 = await loadImg(originUrl).catch(() => {
    });
    let img2 = await loadImg(otherUrl).catch(() => {
    });
    let width = img1.width;
    canvas.width = width;
    canvas.height = img1.height + plusHeight;
    ctx.drawImage(img1, 0, 0, width, img1.height, 0, 0, width, img1.height);
    if (plusHeight > img2.height) {
        let time = Math.ceil(plusHeight / (+img2.height));
        for (let i = 0; i < time; i++) {
            ctx.drawImage(img2, 0, 0, width, img2.height, 0, (img1.height + (i * img2.height)) - 2, width, img2.height);
        }
    } else {
        ctx.drawImage(img2, 0, 0, width, img2.height, 0, img1.height - 2, width, img2.height);
    }
    canvas.remove();
    return Promise.resolve(canvas.toDataURL("image/png"));
}
util.extendImgForHorizontal = async function (url, extendWidth) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    let img = await loadImg(url);
    let imgWidth = img.width, imgHeight = img.height;
    ctx.fillStyle = 'rgba(255, 255, 255, 0)';
    canvas.width = imgWidth + extendWidth;
    canvas.height = imgHeight;
    if (extendWidth > 0) {
        let halfWidth = imgWidth / 2;
        ctx.drawImage(img, 0, 0, halfWidth, img.height, 0, 0, halfWidth, img.height);
        for (let i = 0; i < extendWidth; i++) {
            ctx.drawImage(img, halfWidth, 0, 1, imgHeight, halfWidth + (1 * i), 0, 1, imgHeight);
        }
        ctx.drawImage(img, halfWidth, 0, halfWidth, imgHeight, halfWidth + extendWidth, 0, halfWidth, imgHeight);
    } else { // extendWidth是负值
        let width = imgWidth / 2 + extendWidth / 2;
        let endPos = imgWidth / 2 - extendWidth / 2;
        ctx.drawImage(img, 0, 0, width, img.height, 0, 0, width, img.height);
        ctx.drawImage(img, endPos, 0, width, imgHeight, width, 0, width, imgHeight);
    }
    canvas.remove();
    return Promise.resolve(canvas.toDataURL("image/png"));
}
util.extendImgForVertical = async function (url, extendHeight) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    let img = await loadImg(url);
    let halfHeight = img.height / 2, imgWidth = img.width, imgHeight = img.height;
    ctx.fillStyle = 'rgba(255, 255, 255, 0)';
    canvas.width = imgWidth;
    canvas.height = imgHeight + extendHeight;
    if (extendHeight > 0) {
        ctx.drawImage(img, 0, 0, imgWidth, halfHeight, 0, 0, imgWidth, halfHeight);
        for (let i = 0; i < extendHeight; i++) {
            ctx.drawImage(img, 0, halfHeight, imgWidth, 1, 0, halfHeight + (1 * i), imgWidth, 1);
        }
        ctx.drawImage(img, 0, halfHeight, imgWidth, halfHeight, 0, halfHeight + extendHeight, imgWidth, halfHeight);
    } else {
        let height = imgHeight / 2 + extendHeight / 2;
        let endPos = imgHeight / 2 - extendHeight / 2;
        ctx.drawImage(img, 0, 0, imgWidth, height, 0, 0, imgWidth, height);
        ctx.drawImage(img, 0, endPos, imgWidth, height, 0, height, imgWidth, height);
    }
    canvas.remove();
    return Promise.resolve(canvas.toDataURL("image/png"));
}
util.download = function (response, fileName) {
    let url = window.URL.createObjectURL(response.data);
    let name = fileName || util.getFileName(response);
    this.downloadByUrl(url, name);
};
util.downloadByUrl = function (url, name) {
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.remove();
};
util.getFileName = (response) => {
    let content = response.headers['content-disposition'];
    if (!content) {
        return null;
    }
    let name = content.split(';')[1].split('=')[1].split('.');
    return decodeURI(name[0]) + '.' + name[1];
};
util.formatterFileSize = (kb) => {
    if (!kb) {
        return null;
    }
    let size = null;
    let unit = 'B';
    if (kb > 1024) {
        size = kb / 1024;
        unit = 'KB';
    }
    if (size > 1024) {
        size = size / 1024;
        unit = 'M';
    }
    return Math.floor(size) + unit;
};
util.getFileSizeNum = function(base64String){
    //1.获取base64字符串长度(不含data:audio/wav;base64,文件头)
    let size0 = base64String.length;

    //2.获取字符串的尾巴的最后10个字符，用于判断尾巴是否有等号，正常生成的base64文件'等号'不会超过4个
    let tail = base64String.substring(size0 - 10);

    //3.找到等号，把等号也去掉,(等号其实是空的意思,不能算在文件大小里面)
    let equalIndex = tail.indexOf("=");
    if (equalIndex > 0) {
        size0 = size0 - (10 - equalIndex);
    }
    let kb = size0 - (size0 / 8) * 2;
    return kb;
}
util.getBase64Size = (base64String) => {
    return util.formatterFileSize(util.getFileSizeNum(base64String));
};
util.getWidthNum = () => {
    let paddingRight = 40;
    let w = document.body.offsetWidth - paddingRight;
    let itemW = w % 240;
    return w - itemW;
};
util.getWidth = () => {
    let w = util.getWidthNum();
    return `width: ${w}px`;
};
const projectKey = 'pid';
util.getStorageProjectId = () => {
    return sessionStorage.getItem(projectKey) || localStorage.getItem(projectKey);
};
util.setStorageProjectId = (projectId) => {
    sessionStorage.setItem(projectKey, projectId);
    localStorage.setItem(projectKey, projectId);
};
util.setSessionStorageProjectId = (projectId) => {
    sessionStorage.setItem(projectKey, projectId);
};
util.isMyProject = (projects, pid) => {
    return projects.some((item) => {
        return item.id === pid
    });
};
util.setActiveProject = (projectItems, urlPid, commit, projectRoles, role) => {
    if (urlPid) {
        if (!util.isMyProject(projectItems, urlPid)) {
            console.warn('url projectId is not exists');
            urlPid = null;
        }
    }
    let pid = urlPid || util.getStorageProjectId();
    let isMyProject = util.isMyProject(projectItems, pid);
    if (!isMyProject && projectItems.length > 0) {
        pid = projectItems[0].id;
    }
    if (projectItems.length === 0) {
        pid = null;
    }
    commit('set_active_project', pid);
    if (role) {
        commit('set_active_project_role', role);
    } else if (pid && projectRoles.length > 0) {
        let projectRole = projectRoles.find((item) => {
            return item.projectId === pid;
        });
        commit('set_active_project_role', projectRole ? projectRole.role : '');
    }
}
util.formatSecondToTime = (second) => {
    let hours = Math.floor(second / 3600);
    let minutes = Math.floor((second % 3600) / 60);
    let seconds = (second % 3600 % 60).toFixed(0);
    return `${hours ? hours + '时' : ''}${minutes ? minutes + '分' : ''}${seconds}秒`;
}
util.isWin = () => {
    return window.navigator.userAgent.indexOf("Windows NT") > -1;
}
util.isMac = () => {
    return window.navigator.userAgent.indexOf("Mac") > -1;
}
util.html2ImgUrl = async function ($el, width, height) {
    let canvas = await this.html2canvas($el, width, height);
    let {url} = await uploadService.uploadFileByBase64(canvas.toDataURL()).catch();
    return url;
}
util.addTopForCurrentItem = function (currentItem, top) {
    let currentOldTop = currentItem.top;
    currentItem.top = top;
    currentItem.bottom = top + (+currentItem.height);
    if (currentItem.children) {
        currentItem.children.forEach((item) => {
            this.addTopForCurrentItem(item, top + (+item.top - currentOldTop)); //移动后父节点的top + 原数据相对父元素的距离
        })
    }
}
util.deepChildren = function (children, emptyList) {
    if (children) {
        children.forEach((item) => {
            if (item.children) {
                this.deepChildren(item.children, emptyList);
            } else {
                emptyList.push(item);
            }
        });
    }
}
util.getScale = function (minWidth, minHeight, width, height) {
    let scale = 1;
    if (minWidth < width) {
        scale = parseFloat((minWidth / width).toFixed(2));
    } else if (minHeight < height) {
        scale = parseFloat((minHeight / height).toFixed(2));
    }
    return scale;
};
util.getScaleWidth = function (minWidth, width) {
    let scale = 1;
    if (minWidth < width) {
        scale = parseFloat((minWidth / width).toFixed(2));
    }
    return scale < 0.1 ? 0.1 : scale;
};
util.getScaleWidthAndHeight = function (minWidth, minHeight, width, height) {
    let scale = 1, scaleW = 1, scaleH = 1;
    if (minWidth < width) {
        scaleW = parseFloat((minWidth / width).toFixed(2));
    }
    if (minHeight < height) {
        scaleH = parseFloat((minHeight / height).toFixed(2));
    }
    scale = scaleW < scaleH ? scaleW : scaleH;
    return scale;
};

function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

util.getUUID = function () {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
util.getWidthAndHeight = function (widthHeight) {
    let obj = {
        width: null, height: null
    }
    if (widthHeight && widthHeight.indexOf('x') > -1) {
        let arr = widthHeight.split('x');
        obj.width = arr[0];
        obj.height = arr[1];
    }
    return obj;
}
util.blobToDataURI = function (blob) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
            resolve(e.target.result);
        }
        reader.onerror = function (e) {
            reject(e);
        }
    });
}
util.insertFontStyle = function (list, win) {
    win = win || window;
    let winDocment = win.document;
    if (!list || list.length === 0) {
        return;
    }
    if (!win.fontNameMap) {
        win.fontNameMap = {};
    }
    let cssTextList = [];
    list.forEach(({name, url}) => {
        if (!win.fontNameMap[name]) {
            win.fontNameMap[name] = true;
            cssTextList.push(
                `@font-face{ font-family:'${name}';src: url('${url}')}`
            );
        }
    })
    if (cssTextList.length === 0) {
        return;
    }
    let cssText = cssTextList.join('\n');
    let style = winDocment.createElement('style');
    let head = winDocment.head || winDocment.getElementsByTagName('head')[0];
    let textNode = winDocment.createTextNode(cssText);
    style.appendChild(textNode);
    head.appendChild(style);
};
util.validateOnBeforeUpload = function (file) {
    if (['image/png', 'image/jpeg', 'image/svg+xml'].indexOf(file.type) > -1) {
        return true;
    } else {
        return false;
    }
};
util.getYktUrl = function (url) {
    return window.atob(url);
}
const YTK_URL = 'yktUrl';
util.setYKTCache = function (thisVue) {
    let errorUrl = thisVue.$route.query.errorUrl;
    thisVue.$router.push({path: '/', query: {errorUrl: errorUrl}});
    sessionStorage.setItem(YTK_URL, errorUrl);
}
util.getHashParams = function () {
    let hash = location.hash;
    let str = hash.substring(hash.indexOf('?') + 1, hash.length);
    let resultOjb = null;
    if (str.trim()) {
        let arr = str.split('&');
        let itemArr = null;
        resultOjb = {};
        arr.forEach((str) => {
            itemArr = str.split('=');
            resultOjb[itemArr[0]] = itemArr[1];
        });
    }
    return resultOjb
}
util.getYKTCache = function () {
    let obj = util.getHashParams();
    let yktUrl = obj ? obj.errorUrl : '';
    return yktUrl || sessionStorage.getItem(YTK_URL);
}
util.clearYKTCache = function () {
    sessionStorage.removeItem(YTK_URL)
}
let cacheFont = [];
util.downloadFont = function (fontFamilyName, fontUrl) {
    if (!fontFamilyName) {
        console.warn('font-family is not null');
        return Promise.reject(false);
    }
    if (cacheFont.indexOf(fontFamilyName) > -1) {
        return Promise.resolve(true);
    }
    let fontFace = new FontFace(fontFamilyName, `url(${fontUrl})`);
    return new Promise((resolve, reject) => {
        fontFace.load().then((font) => {
            cacheFont.push(fontFamilyName);
            document.fonts.add(font);
            resolve(true);
        }).catch((error) => {
            console.error(`字体解析异常：${fontFamilyName}`);
            reject(error);
        });
    });
}
util.getBgByDeep = function (item, bgList) {
    if (item.children) {
        let i, obj;
        for (i = 0; i < item.children.length; i++) {
            obj = item.children[i];
            if (obj.children) {
                this.getBgByDeep(obj, bgList);
            } else if (obj.isPageBgImg) {
                bgList.push(obj);
            }
        }
    }
}
util.runDelay = function (time, cb) {
    if (this.time) {
        clearTimeout(this.time)
    }
    this.time = setTimeout(() => {
        this.time = null;
        cb();
    }, time);
}
util.getRGBANumArray = function (str) {
    return str.match(/(\d(\.\d+)?)+/g);
}
util.setVueAttr = function (thisVue, item, attr, value) {
    if (item[attr] === undefined) {
        thisVue.$set(item, attr, value);
    } else {
        item[attr] = value;
    }
}
util.setImgColor = function (url, color, opacity = 0) {
    return new Promise((resolve, reject) => {
        let colorArray = util.getRGBANumArray(color);
        if (colorArray === null) {
            resolve('请使用rgba颜色值');
            return;
        }
        let img = new Image();
        img.src = url + '?v=' + new Date().getTime();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext("2d");
            let width = img.width, height = img.height;
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            let imgData = ctx.getImageData(0, 0, width, height);
            let a;
            for (let i = 0; i < imgData.data.length; i += 4) {
                a = imgData.data[i + 3];
                if (a > opacity) {
                    imgData.data[i] = +colorArray[0];
                    imgData.data[i + 1] = +colorArray[1];
                    imgData.data[i + 2] = +colorArray[2];
                }
            }
            ctx.putImageData(imgData, 0, 0);
            uploadService.uploadFileByBase64(canvas.toDataURL()).then(({url}) => {
                resolve(url);
            }).catch((error) => {
                console.error(error);
                reject('图片颜色替换失败');
            })
        }
        img.onerror = (error) => {
            console.error(error);
            reject('图片颜色替换失败');
        };
    });
}
util.getPxNum = function (pxVal) {
    return pxVal.indexOf('px') > -1 ? +pxVal.replace('px', '') : pxVal
}
util.formatterTextShadow = function ({list, fontColor}) {
    let result = [], backgroundArray = [];
    list.forEach((textShadowObj) => {
        result.push(`${textShadowObj.hShadow}px ${textShadowObj.vShadow}px ${textShadowObj.blur}px ${textShadowObj.color}`);
        if (textShadowObj.backgroundImageUrl) {
            backgroundArray = [
                `-webkit-background-clip: ${textShadowObj.webkitBackgroundClip}`,
                `background-image:url(${textShadowObj.backgroundImageUrl})`,
                `background-size:${textShadowObj.backgroundSize}`,
                `background-repeat:${textShadowObj.backgroundRepeat}`,
                `-webkit-text-fill-color: transparent`
            ]
        }
    });
    let styleArray = [`color:${fontColor}`, `text-shadow: ${result.join(',')}`].concat(backgroundArray);
    return styleArray.join(';');
};
const getRgbByHex = function (sColor) {
    let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    sColor = sColor.toLowerCase();
    if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
            let sColorNew = "#";
            for (let i = 1; i < 4; i += 1) {
                sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
        }
        //处理六位的颜色值
        let sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return sColorChange;
    } else if (sColor.indexOf('rgb') === 0) {
        return util.getRGBANumArray(sColor);
    } else {
        return sColor;
    }
}
util.getRgbByHex = getRgbByHex;
util.getGradientColorList = function (startColor, endColor, step = 10) {
    let startRGB, startR, startG, startB, endRGB, endR, endG, endB, sR, sG, sB;
    startRGB = getRgbByHex(startColor);//转换为rgb数组模式
    startR = startRGB[0];
    startG = startRGB[1];
    startB = startRGB[2];
    endRGB = getRgbByHex(endColor);
    endR = endRGB[0];
    endG = endRGB[1];
    endB = endRGB[2];
    sR = (endR - startR) / step;//总差值
    sG = (endG - startG) / step;
    sB = (endB - startB) / step;
    let colorArr = [];
    for (let i = 0; i < step; i++) {
        colorArr.push('rgb(' + parseInt((sR * i + startR)) + ',' + parseInt((sG * i + startG)) + ',' + parseInt((sB * i + startB)) + ')');
    }
    return colorArr;
};
const cacheFontByQuery = function (fontNameList) {
    let cacheFonts = window.__proto__.cacheFonts || {};
    fontNameList.forEach((name) => {
        cacheFonts[name] = true;
    });
    window.__proto__.cacheFonts = cacheFonts;
}
const validateCacheFont = function (fontNameList) {
    let cacheFonts = window.__proto__.cacheFonts;
    if (!cacheFonts) {
        return fontNameList;
    }
    fontNameList = fontNameList.filter((name) => {
        return !cacheFonts[name]
    });
    return fontNameList;
}
util.appendFontStyle = function (projectId, fontNameList) {
    if (!fontNameList || fontNameList.length === 0) {
        return Promise.resolve('fontNameList is empty')
    }
    fontNameList = validateCacheFont(fontNameList);
    if (fontNameList.length === 0) {
        return Promise.resolve('字体已加载过');
    }
    cacheFontByQuery(fontNameList);
    return new Promise((resolve, reject) => {
        fontService.getFontListByNames(projectId, fontNameList).then((fontList) => {
            if (fontList) {
                let fontDataList = [];
                fontList.forEach((item) => {
                    fontDataList.push({
                        name: item.name,
                        url: item.url
                    });
                });
                util.insertFontStyle(fontDataList);
            }
            resolve();
        }).catch((error) => {
            reject(error)
        });
    });
};
util.goHomeBefore = function (thisVue, hasChange) {
    if (hasChange) {
        thisVue.$confirm('确定退出当前编辑页面?', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            thisVue.$router.push('/template')
        }).catch(() => {
        });
    } else {
        thisVue.$router.push('/template')
    }
};
util.isSvgUrl = function(url){
    let urlObj = new window.URL(url);
    let pathname = urlObj.pathname;
    return pathname.endsWith('.svg');
}
util.isSvg = function(file){
    return file.type === 'image/svg+xml';
}
util.getSvgHtml = function (file) {
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.readAsText(file);
        fileReader.onload = (ret) => {
            resolve(ret.target.result);
        };
        fileReader.onerror = (error) => {
            reject(error)
        }
    })
}
const getRatioByMinVal = function(width, height){
    let minVal = width > height ? height : width;
    return minVal / 1024;
}
util.setSvgViewBox = function(svg, width, height){
    if(!svg){
        return svg;
    }
    let div = document.createElement('div');
    div.innerHTML = svg;
    let svgDom = div.querySelector('svg');
    let ratio = getRatioByMinVal(width, height);
    let w = parseInt(width / ratio), h = parseInt(height / ratio);
    svgDom.setAttribute('viewBox', `0 0 ${w} ${h}`);
    svgDom.setAttribute('preserveAspectRatio', 'none');
    return div.innerHTML;
}
util.toStyleAttr = function(name) { //驼峰转横线
    return name.replace(/([A-Z])/g,"-$1").toLowerCase();
};
util.splitTwoRgbaValues = function(value){ // rgb(247, 143, 173, rgb(253, 235, 130) or #ffffff, #cccccc
    let temp = ', rgb';
    value = value.trim().toLowerCase();
    if(value.indexOf(temp) > -1){
        return  value.replace(temp, ';rgb').split(';')
    } else if(value.indexOf(',') > -1){
        return value.split(',');
    }
    return [value];
}
const getFont = function(css){
    if(css && css.indexOf(';') > -1){
        let arr = css.split(';').filter((attr) => {
            return attr.indexOf('font-family') > -1
        });
        if(arr.length > 0){
            return arr[0].split(':')[1].trim();
        }
        return '';
    }else{
        return '';
    }
}
util.getFontListFromStyle = function(vnodeChildren){
    let dataList = [];
    vnodeChildren.forEach((item) => {
        if(item.data && item.data.attrs.style){
            let f = getFont(item.data.attrs.style);
            if(f){
                dataList.push(f);
            }
        }
        if(item.children){
           let temp = this.getFontListFromStyle(item.children);
            dataList.push(...temp);
        }
    });
    return dataList;
}
util.validateTextLen = function(ev, maxVal) {
    if (maxVal === 0 || !ev.target.textContent) {
        return true;
    }
    let str = ev.target.textContent.replaceAll('\r', '');
    let textLen = str.length;
    let hasError = textLen > maxVal;
    if (hasError) {
        if (!window.moreTextErrorMsg) {
            window.moreTextErrorMsg = true;
            this.$message({
                showClose: true,
                message: `请保持文本长度在${maxVal}个字符以内`,
                type: 'error',
                duration: 5000,
                onClose: () => {
                    window.moreTextErrorMsg = null;
                }
            });
        }
    }
    return hasError;
};
util.isIE = function(){
  return window.navigator.userAgent.indexOf("MSIE") > -1 ||  window.navigator.userAgent.indexOf("Edge") > -1;
};
util.rgba2hex = (orig) => {
  let a
  let rgb = orig
    .replace(/\s/g, '')
    .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)
  let alpha = ((rgb && rgb[4]) || '').trim()
  let hex = rgb
    ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
      (rgb[2] | (1 << 8)).toString(16).slice(1) +
      (rgb[3] | (1 << 8)).toString(16).slice(1)
    : orig

  if (alpha !== '') {
    a = parseInt(alpha) > 1 ? 100 : alpha * 100
  } else {
    a = null
  }
  // hex = hex + a
  return [hex, Math.round(a)]
}
export default util;